
import { useEffect } from "react";
import { Card } from "@/components/ui/card";
import { BillsPageHeader } from "./bills/BillsPageHeader";
import { BillsContent } from "./bills/BillsContent";
import { useBillsData } from "./bills/hooks/useBillsData";
import { useBillActions } from "./bills/hooks/useBillActions";
import { PAGE_SIZE } from "./bills/types";

interface BillsOverviewProps {
  initialFilter?: string | null;
}

export function BillsOverview({ initialFilter }: BillsOverviewProps = {}) {
  const {
    bills,
    loading,
    updating,
    setUpdating,
    searchTerm,
    setSearchTerm,
    statusFilter,
    setStatusFilter,
    totalCount,
    currentPage,
    setCurrentPage,
    pageSize,
    setPageSize,
    fetchBills
  } = useBillsData(initialFilter);

  const {
    selectedBillId,
    isDialogOpen,
    dialogAction,
    handleUpdateStatus,
    handleUpdateClick,
    handleCancelClick,
    handleDialogClose
  } = useBillActions({
    onSuccess: fetchBills,
    setUpdating
  });

  const totalPages = Math.ceil(totalCount / pageSize);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      document.body.style.removeProperty('pointer-events');
    };
  }, []);

  return (
    <Card>
      <BillsPageHeader 
        pageSize={pageSize}
        onPageSizeChange={(size) => {
          setPageSize(size);
          setCurrentPage(1);
        }}
        statusFilter={statusFilter}
        onStatusFilterChange={setStatusFilter}
        searchTerm={searchTerm}
        onSearchChange={setSearchTerm}
      />
      
      <BillsContent 
        bills={bills}
        loading={loading}
        updating={updating}
        totalPages={totalPages}
        currentPage={currentPage}
        onPageChange={setCurrentPage}
        onUpdateStatus={handleUpdateClick}
        onCancelBill={handleCancelClick}
        selectedBillId={selectedBillId}
        isDialogOpen={isDialogOpen}
        dialogAction={dialogAction}
        onDialogOpenChange={handleDialogClose}
        onDialogConfirm={handleUpdateStatus}
      />
    </Card>
  );
}
